import type React from "react";
import { LogoutIcon } from "~/components/icons";

export const LogoutButton: React.FC = () => {
	return (
		<a href="/logout">
			<LogoutIcon color="white" />
		</a>
	);
};
